import { useModals } from 'almanac-ui/Modal'
import { ContentTypeProps } from 'components/ContentType/Types'
import { ASPECT_RATIOS, AspectRatioKey, DesignChannels } from 'components/NewFileModal/Types'
import { FlowA2 } from 'components/Wizards/DesktopWizards/Flows/FlowA2/FlowA2'
import { FlowB } from 'components/Wizards/DesktopWizards/Flows/FlowB/FlowB'
import { FlowC } from 'components/Wizards/DesktopWizards/Flows/FlowC/FlowC'
import { DesktopWizardProps, FlowKey, FlowWizards } from 'components/Wizards/DesktopWizards/Types'
import { Wizard } from 'components/Wizards/WizardsDrawer/WizardsDrawerV4/Types'
import { desktopDesignSchemas } from 'components/Wizards/schemas/desktopSchemas'
import { MinimalBlogPostWizard } from 'components/Wizards/BlogPostWizard/MinimalBlogPostWizard'
import { BlogPostSchema } from 'components/Wizards/schemas/BlogPost'

export type WizardOpenerHookProps = Omit<ContentTypeProps, 'type' | 'children'> & {
  type: Wizard
  initialValues?: Record<string, any>
}

/**
 * Hook that provides functionality to open wizard modals
 *
 * @returns Function to open the wizard modal
 */
export const useWizardOpener = () => {
  const { openModal } = useModals()

  const openWizard = (props: WizardOpenerHookProps) => {
    const { type, initialValues, onSuccess, ...rest } = props

    const flow = FlowWizards[type as AspectRatioKey]
    const contentType = DesignChannels[type as AspectRatioKey]
    const schema = desktopDesignSchemas[contentType]
    const { width, height } = ASPECT_RATIOS[(type || 'instagram-portrait-post') as AspectRatioKey] || {}

    const params = {
      schema: schema,
      onSuccess,
      initialValues: {
        width,
        height,
        ...initialValues,
      },
      ...rest,
    } as DesktopWizardProps

    if (type === 'blog_post') {
      openModal(MinimalBlogPostWizard, { schema: BlogPostSchema, initialValues, onSuccess }, { newStack: true })
      return
    }

    if (!schema) return

    if (flow === FlowKey.A2) {
      openModal(FlowA2, params, { newStack: true })
    }

    if (flow === FlowKey.B) {
      openModal(FlowB, params, { newStack: true })
    }

    if (flow === FlowKey.C) {
      openModal(FlowC, params, { newStack: true })
    }
  }

  return openWizard
}
